

export const generateSearchId = () => {
    return (Math.random() + 1).toString(36).slice(2, 9);
};
